import { Check, Circle, ExternalLink } from "lucide-react";

export default function JupiterTracker({ coin }) {
  if (!coin.mint_address) return null;
  const mintedAt = coin.minted_at || coin.created_at;
  const ageDays = mintedAt ? Math.floor((Date.now() - new Date(mintedAt).getTime()) / 86400000) : 0;
  const items = [
    { label: "On-chain mint", done: true },
    { label: "Live liquidity pool", done: Boolean(coin.lp_pool_id) },
    { label: `Token age 21+ days (${Math.min(ageDays, 21)}/21)`, done: ageDays >= 21 },
    { label: "~$100k market cap · ~500 holders · ~$10k daily volume", done: false, external: true },
  ];
  return (
    <div className="border border-[#3a3a3a] bg-[#121212] p-6 mb-6" data-testid="jupiter-tracker">
      <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#00D4FF] mb-4">
        // Jupiter verified — progress
      </div>
      <div className="space-y-2.5 mb-4">
        {items.map((it) => (
          <div key={it.label} className="flex items-center gap-3 text-sm">
            {it.done ? (
              <Check size={14} className="text-[#00ff41] flex-shrink-0" />
            ) : (
              <Circle size={14} className="text-[#8a8a8a] flex-shrink-0" />
            )}
            <span className={it.done ? "text-white" : "text-[#d0d0d0]"}>{it.label}</span>
            {it.external && !it.done && (
              <span className="font-mono text-[10px] uppercase text-[#b8b8b8]">grows with trading</span>
            )}
          </div>
        ))}
      </div>
      <a
        href="https://verified.jup.ag"
        target="_blank"
        rel="noreferrer"
        data-testid="jupiter-apply-link"
        className="font-mono text-xs uppercase tracking-widest text-[#00D4FF] hover:underline inline-flex items-center gap-1.5"
      >
        Apply at verified.jup.ag <ExternalLink size={11} />
      </a>
    </div>
  );
}
